// @flow

import React from 'react';
import { Helmet } from 'react-helmet';

export type FaviconProps = {
  appleTouchIcon: string,
  icon16: string,
  icon32: string,
  shortCutIcon: string
};

export const Favicon = ({
  appleTouchIcon,
  icon16,
  icon32,
  shortCutIcon
}: FaviconProps) => (
  <Helmet preserved>
    <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
    <link rel="icon" type="image/png" sizes="32x32" href={icon32} />
    <link rel="icon" type="image/png" sizes="16x16" href={icon16} />
    <link rel="shortcut icon" href={shortCutIcon} />
  </Helmet>
);

Favicon.displayName = 'Favicon';
export default Favicon;
